import React from "react";

const contactMapList = [
  {
    imgUrl: "assets/images/contact/01.png",
    imgAlt: "contact",
    title: "Class Sessions",
    infoList: [
      {
        text: "Monday - Saturday",
      },
      {
        text: "09:00 am – 6:00 am (Sun Closed)",
      },
    ],
  },
  {
    imgUrl: "assets/images/contact/02.png",
    imgAlt: "contact",
    title: "kittons Address",
    infoList: [
      {
        text: "44, Ilyas Colony",
      },
      {
        text: "Khajrana, Indore 452001, Madhya Pradesh, India",
      },
    ],
  },
  {
    imgUrl: "assets/images/contact/03.png",
    imgAlt: "contact",
    title: "Working Hours",
    infoList: [
      {
        text: "Monday - Saturday",
      },
      {
        text: "09.00 am – 06.00 pm",
      },
    ],
  },
  {
    imgUrl: "assets/images/contact/04.png",
    imgAlt: "contact",
    title: "Phone & E-mail",
    infoList: [
      {
        text: "+91 799-337-67",
      },
      {
        text: "enquiries@myhorizonacademy.in",
      },
    ],
  },
];

const GoogleMap = () => {
  return (
    <div className="map-section pos-rel">
      <div className="maps">
        <iframe
          src="https://www.google.com/maps/embed/v1/place?key=AIzaSyADDoBblHt3R8p6wmKYOOdathS_Teow0vQ&q=44,%20Ilyas%20Colony%20Rd,%20Khajrana,%20Indore,%20Madhya%20Pradesh%20452016,%20India"
          loading="lazy"
        ></iframe>
      </div>
      <div className="contact-area padding-bottom padding-top pt-lg-0 pb-lg-0">
        <div className="container">
          <div className="contact-wrapper">
            {contactMapList.map((val, i) => (
              <div className="contact-item" key={i}>
                <div className="contact-thumb">
                  <img src={`${val.imgUrl}`} alt={`${val.imgAlt}`} />
                </div>
                <div className="contact-content">
                  <h6 className="title">{val.title}</h6>
                  <ul>
                    {val.infoList.map((val, i) => (
                      <li key={i}>{val.text}</li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GoogleMap;
